import React from 'react';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import randomstring from 'uuid/v4';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import Local from './Local';


class List extends React.Component {



    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    }

    render() {
        const { locals, locals_is_loading, locals_has_errored } = this.props;

        if (locals_has_errored.hasErrored) {
            return <Error open type={locals_has_errored.hasErrored}  message={locals_has_errored.error} handleClose={this.handleBack} />;
        } else if (locals === undefined) {
            return (
                <Error
                    open
                    message={<FormattedMessage id="error_clients_not_found" />}
                    handleClose={this.handleBack}
                />
            );
        } else {
            return (
                <div className={'flex_full_column padding_bottom_9 padding_top_12 height100'}>
                    {locals_is_loading && <Loading open opacity />}
                    <div className="flex_full overflow_y_scroll">
                        {locals
                            .sort((a, b) => a.nombre > b.nombre ? 1 : -1)
                            .filter((f) => this.props.window_searchs.filter((s) => f.nombre.toUpperCase().includes(s)).length > 0
                                || this.props.window_searchs.length === 0)
                            .map((local, index) => {
                                return <Local {...this.props} key={randomstring()} data={local} last={index === locals.length} />;
                            })}
                    </div>
                </div>
            );
        }
    }
}

export default withRouter(List);



// WEBPACK FOOTER //
// ./src/components/complex/manage/locals/List.js